// extracted by mini-css-extract-plugin
export default {"windTile":"wind-tile_windTile__iBLfe","largeText":"wind-tile_largeText__dowLk","windContainer":"wind-tile_windContainer__VVSrj"};